export default "__VITE_ASSET__DbHHBTOp__"